export const useSwiperControlsVisibility = (
  count: Ref<number>,
  breakpoint: Ref<string>,
) =>
  computed(() => {
    let visibleSlides: number;

    switch (breakpoint.value) {
      case 'desktop':
        visibleSlides = 3;
        break;
      case 'tablet':
      case 'tabletBig':
      case 'mobileBig':
        visibleSlides = 2;
        break;
      case 'mobile':
      case 'xs':
      default:
        visibleSlides = 1;
        break;
    }

    return count.value > visibleSlides;
  });
